import {get, isNil} from 'lodash'
import {excludedPartTemplatesForOptions, isPartTypePricingCalculator, PartType} from 'helpers/parts'

export const getPartTemplateIdFromPriceList = (priceList, partTemplates = []) => {
  const partTemplateId = get(priceList, 'rootCategory.partTemplateId', null)
  const partType = get(priceList, 'rootCategory.partType', null)
  return isNil(partTemplateId)
    ? get(getPartTemplateFromPartType(partType, partTemplates), 'id', null)
    : partTemplateId
}

export const getPartTemplateFromPartType = (partType, partTemplates = []) => {
  return partTemplates.find(partTemplate => partTemplate.partType === partType)
}

export const getPartTemplateAttributesFor = (partTemplateId, partTemplates = []) => {
  if (isNil(partTemplateId)) return []
  const partTemplate = partTemplates.find(partTemplate => partTemplate.id === partTemplateId)
  return get(partTemplate, 'attributes', [])
}

export const mapPartTemplatesToOptions = (partTemplates, includedPartTypes = []) => {
  return partTemplates
    .filter(partTemplate => partTemplate.partType !== null)
    .filter(partTemplate => {
      return includedPartTypes.includes(partTemplate.partType)
        || !excludedPartTemplatesForOptions.includes(partTemplate.partType)
    })
    .map(partTemplate => {
      return {
        key: partTemplate.id,
        value: partTemplate.id,
        label: partTemplate.name,
      }
    })
}

export const getPartTemplateById = (id, partTemplates = []) => partTemplates.find(p => p.id === id)

export const isPricingCalculatorPartTemplate = (partTemplateId, partTemplates = []) => {
  const partTemplate = getPartTemplateById(partTemplateId, partTemplates)
  return isPartTypePricingCalculator(get(partTemplate, 'partType', null))
}

export const getIncludedPartTypes = (partToDuplicate, isPricingCalculatorEnabled) => {
  const isAddingPricingCalculator = isNil(partToDuplicate) && isPricingCalculatorEnabled
  const isDuplicatingPricingCalculator = isPartTypePricingCalculator(get(partToDuplicate, 'type', null))
  return isAddingPricingCalculator || isDuplicatingPricingCalculator
    ? [PartType.GO_PRICING_CALCULATOR.id]
    : []
}
